import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/code.jpg'


const _withScopeId = n => (_pushScopeId("data-v-312bc73e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-box" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "logo-img" }
const _hoisted_5 = { alt: "" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "address" }
const _hoisted_8 = { class: "address" }
const _hoisted_9 = { class: "address" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "address" }
const _hoisted_12 = { class: "address" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = { class: "address" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 电话：0592-7272801", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont" }, ""),
  /*#__PURE__*/_createElementVNode("span", null, " 邮箱：contact@rekeymed.com ")
], -1))
const _hoisted_17 = { class: "address" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地址：厦门市集美区灌口镇集美北大道安仁产业园1068-17号7楼", -1))
const _hoisted_19 = { class: "address" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 网址：https://rekeymed.com", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "扫一扫关注我们")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "privacy" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ythzxfw.miit.gov.cn/index",
      target: "blank"
    }, "版权所有 © 厦门瑞聚医学科技有限公司")
  ])
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomView',
  setup(__props) {

const handleSelect = (key: string, keyPath: string[]) => {
  sessionStorage.setItem("activeIndex", key);
  router.push(key);
};

return (_ctx: any,_cache: any) => {
  const _component_PhoneFilled = _resolveComponent("PhoneFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_LocationFilled = _resolveComponent("LocationFilled")!
  const _component_Promotion = _resolveComponent("Promotion")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_directive_lazy, require('@/assets/LOGO-white.png')]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            class: "a",
            href: "/",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelect('/')))
          }, _toDisplayString(_ctx.$t("Home Page")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            class: "a",
            href: "/about",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelect('/about')))
          }, _toDisplayString(_ctx.$t("About")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            class: "a",
            href: "/tech",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelect('/tech')))
          }, _toDisplayString(_ctx.$t("Innovative Technology")), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            class: "a",
            href: "/service",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSelect('/service')))
          }, _toDisplayString(_ctx.$t("ServiceCenter")), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            class: "a",
            href: "/companynews",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSelect('/companynews')))
          }, _toDisplayString(_ctx.$t("Company News")), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            class: "a",
            href: "/industrynews",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSelect('/industrynews')))
          }, _toDisplayString(_ctx.$t("Industry News")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_icon, {
            size: "14",
            style: {"color":"#fff"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PhoneFilled)
            ]),
            _: 1
          }),
          _hoisted_15
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_icon, {
            size: "14",
            style: {"color":"#fff"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LocationFilled)
            ]),
            _: 1
          }),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_icon, {
            size: "14",
            style: {"color":"#fff"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Promotion)
            ]),
            _: 1
          }),
          _hoisted_20
        ])
      ]),
      _hoisted_21
    ]),
    _hoisted_22
  ]))
}
}

})